import Vue from 'vue'

import afterColumn from './required-column-after-column'
Vue.component(afterColumn.name, afterColumn)

export default {
    slots() {
        return [
            {
                slot: "after-column",
                component: afterColumn.name
            }
        ]
    },
    mixins() {
        return {
            inject: {
                form: {
                    default: false
                }
            },
            props: {
                prefix: {
                    type: String
                }
            },
            computed: {
                requiredColumns(){
                    let requiredColumns = []

                    if (this.form) {
                        this.getColumns().map(col => col.field).forEach((field) => {
                            if (this.form.getValidator().isRequired(`${this.prefix}.${field}`)) {
                                if (requiredColumns.indexOf(field) === -1) {
                                    requiredColumns.push(field)
                                }
                            }
                        })
                    }

                    return requiredColumns
                }
            }
        }
    }
}
